import { render } from "./GifControlEditor.vue?vue&type=template&id=58499476&scoped=true&ts=true"
import script from "./GifControlEditor.vue?vue&type=script&lang=ts"
export * from "./GifControlEditor.vue?vue&type=script&lang=ts"

import "./GifControlEditor.vue?vue&type=style&index=0&id=58499476&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58499476"]])

export default __exports__